import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Report } from "../types";

type GetFindReportParams = {
	report: number;
};

const fetchFindReport = async (report: number): Promise<Report | null> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getFindReports",
		bind: {
			report: report,
		},
	});

	const result = response.data.result;
	return result && result.length > 0
		? {
				...result[0],
				lossObjectImages: safeParseImages(result[0].lossObjectImages),
			}
		: null;
};

export const useGetFindReport = ({ report }: GetFindReportParams) => {
	return useQuery<Report | null>({
		queryKey: ["getFindReport", report],
		queryFn: () => fetchFindReport(report),
		enabled: !!report,
	});
};

// Helper to safely parse images JSON
const safeParseImages = (input: string): string[] => {
	try {
		const parsed = JSON.parse(input);
		return Array.isArray(parsed) ? parsed : [];
	} catch {
		return [];
	}
};
